import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withTranslation } from "react-i18next";

import "./ManagerFiltersHeader.scss";

//Reactstrap
import {
  Container,
  Row,
  Col,
  Button,
  Label,
  Input,
  Card,
  CardTitle,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Popover,
  PopoverBody,
} from "reactstrap";

import { AvForm, AvField } from "availity-reactstrap-validation";

import toastr from "toastr";

import ManagerFilterButton from "./sub/ManagerFilterButton/index";

import FilterSelect from "../../../Common/FilterSelect";

import BadgesEllipsisSoft from "../../../../components/Common/BadgesEllipsisSoft";

import {
  getConversationsForm,
  getUserFilter,
  resetUserFilter,
  updateUserFilter,
} from "../../../../store/manager/actions";
import ButtonCheckboxTree from "./sub/ButtomCheckboxTree";

const ManagerFilterHeader = ({ t }) => {
  const dispatch = useDispatch();

  const {
    dataConversationForm,
    loadingConversationForm,
    dataUserGetSetFilter,
    loadingUserUpdateFilter,
    successUserFilter,
    loadingUserFilter,
  } = useSelector((state) => state.Manager);

  const defaultFilter = {
    interval: 24,
    skills: [],
    groups: [],
  };

  const hour = 24;

  const getHourArray = () => {
    return(
      [...Array(hour).keys()].map((i) => ({
        id: hour - i,
        name: t("Last") + " " + (hour - i) + "h",
      }))
    )
  }

  const mainTheme = useSelector((state) => state.Layout.mainTheme);
  const generalFilter = useSelector((state) => state.Manager.dataGeneralFilter);

  const [filter, setFilter] = useState(defaultFilter);
  const [searchFilter, setSearchFilter] = useState("");
  const [modal, setModal] = useState(false);
  const [nameFilter, setNameFilter] = useState("");
  const [filterSelected, setFilterSelected] = useState({});
  const [template, setTemplate] = useState(null);
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [infoGroups, setInfoGroups] = useState([]);
  const [dataPeriods,setDataPeriods] = useState(getHourArray())

  const togglePop = () => setPopoverOpen(!popoverOpen);


  useEffect(()=>{
    setDataPeriods(getHourArray())
  },[t])

  const [dataSkills, setDataSkills] = useState([]);
  const [dataGroups, setDataGroups] = useState([]);

  const toggle = () => setModal(!modal);

  const showToast = (type, message) => {
    toastr.options = {
      closeButton: false,
      debug: false,
      newestOnTop: false,
      progressBar: true,
      positionClass: "toast-top-right",
      preventDuplicates: true,
      onclick: null,
      showDuration: "200",
      hideDuration: "200",
      timeOut: "2000",
      extendedTimeOut: "2000",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
    };
    toastr[type](message);
  };

  const checkName = (name) => {
    return dataUserGetSetFilter?.data?.template_filters?.some(
      (el) => el.name === name
    );
  };

  const getNameSkills = () => {
    const skillInfo = dataSkills.reduce((acc, item) => {
      const temp = filter?.skills.find((el) => el === item.id);
      if (temp) {
        acc.push({
          name: item.name,
        });
      }
      return acc;
    }, []);
    return skillInfo;
  };

  const getNameGroups = () => {
    const names = infoGroups.reduce((acc, item) => {
      const temp = filter?.groups.find((el) => el === item.uuid);
      if (temp) {
        acc.push({
          name: item.label,
        });
      }
      return acc;
    }, []);
    return names;
  };

  const validationGroups = (filterGroups) => {
    const arrayGroups = infoGroups?.map((el) => el.uuid);
    const filterGroupId = filterGroups?.groups.map((el) => el);

    let valid = [];
    for (let i = 0; i < arrayGroups.length; i++) {
      for (let j = 0; j < filterGroupId.length; j++) {
        if (arrayGroups[i] === filterGroupId[j]) {
          valid.push(arrayGroups[i]);
        }
      }
    }
    return filterGroupId.length === valid.length ? true : false;
  };

  const validationSkills = (filterSkills) => {
    const arraySkills = dataSkills?.filter((el, key) => {
      if (key !== 0) {
        return el;
      }
    });
    const arrayId = arraySkills.map((el) => el.id);
    const filterSkillId = filterSkills.skills.map((el) => el);

    let valid = [];
    for (let i = 0; i < arrayId.length; i++) {
      for (let j = 0; j < filterSkillId.length; j++) {
        if (filterSkillId[j] === arrayId[i]) {
          valid.push(arrayId[i]);
        }
      }
    }
    return filterSkillId.length === valid.length ? true : false;
  };

  const handleResetFilters = (e) => {
    setFilter(defaultFilter);
    setTemplate(defaultFilter);
    setFilterSelected({});
  };

  const handleFilters = (e) => {
    try {
      const option = dataUserGetSetFilter?.data?.template_filters.find(
        (el) => el.name === e.target.innerHTML
      );

      if (option?.skills?.length) {
        const validSkills = validationSkills(option);
        if (!validSkills) {
          setFilterSelected(e.target.innerHTML);
          setFilter(defaultFilter);
          setTemplate(defaultFilter);
          throw new Error(
            t(
              "This filter contains skills you do not have permission to access. Default filters actived."
            )
          );
        }
      }

      if (option?.groups?.length) {
        const validGroups = validationGroups(option);
        if (!validGroups) {
          setFilterSelected(e.target.innerHTML);
          setFilter(defaultFilter);
          setTemplate(defaultFilter);
          throw new Error(
            t(
              "This filter contains groups you do not have permission to access. Default filters actived."
            )
          );
        }
      }

      const data = {
        interval: option?.interval === "" ? 24 : option?.interval,
        skills: option?.skills,
        groups: option?.groups,
      };
      setFilterSelected(e.target.innerHTML);
      setFilter(data);
      setTemplate(data);
    } catch (error) {
      showToast("error", error.message);
    }
  };
  const handleChangeSearch = (e) => {
    setSearchFilter(e.target.value);
  };

  const handleChangeNameFilter = (e) => {
    setNameFilter(e.target.value);
  };

  const onDeleteFilter = async (e) => {
    try {
      const dataUser = JSON.parse(localStorage.getItem("authUser"));
      const templateFilters = {
        template_filters: {
          name: filterSelected,
          action: "delete",
        },
      };
      dispatch(updateUserFilter(dataUser.user.id, templateFilters));
      handleResetFilters();
    } catch (error) {
      showToast("error", error.message);
    }
  };

  const onSubmitFilter = () => {
    try {
      if (checkName(nameFilter)) {
        throw new Error(t("This filter name already exists"));
      }
      if (
        filter?.groups?.length === 0 &&
        filter?.skills?.length === 0 &&
        filter?.interval === 24
      ) {
        throw new Error(t("Default filters can't be saved"));
      } else {
        const dataUser = JSON.parse(localStorage.getItem("authUser"));
        const templateFilters = {
          template_filters: {
            name: nameFilter,
            groups: filter?.groups,
            interval: filter?.interval,
            skills: filter?.skills,
          },
        };
        dispatch(updateUserFilter(dataUser.user.id, templateFilters));
      }
    } catch (error) {
      showToast("error", error.message);
    }
  };
  useEffect(() => {
    if (dataConversationForm?.form?.skills) {
      let firstOpt = [{ id: 0, name: t("All skills"), isFixed: true }];
      let restOpt = dataConversationForm?.form?.skills;
      setDataSkills(firstOpt.concat(restOpt));
    }
  }, [dataConversationForm?.form?.skills, t]);

  useEffect(() => {
    if (dataConversationForm?.form?.groups) {
      let restOpt = dataConversationForm?.form?.groups;
      let firstOpt = [
        { label: t("All groups"), uuid: 1, children: restOpt || [] },
      ];
      setDataGroups(firstOpt);
    }
  }, [dataConversationForm?.form?.groups, t]);

  useEffect(() => {
    dispatch(getConversationsForm());
  }, [dispatch]);

  useEffect(() => {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    if (successUserFilter) {
      showToast("success", t("Successful operation"));
      dispatch(resetUserFilter());
      setModal(false);
    }
    dispatch(getUserFilter(authUser.user.id));
  }, [successUserFilter, dispatch, t]);

  useEffect(() => {
    if (!modal) {
      setNameFilter("");
    }
  }, [modal]);

  return (
    <React.Fragment>
      <Container className="d-flex w-100 px-0 m-2" fluid={true}>
        <div className="d-flex flex-wrap w-100 mx-0 mb-2">
          <div className="header-select interval">
            <FilterSelect
              name="interval"
              defaultValue={template || generalFilter}
              filterItemExtraStyle=""
              filterItemIcon="bx bx-calendar-alt"
              filterItemTitle={t("Period")}
              data={dataPeriods}
              onChange={(target, e) =>
                setFilter({ ...filter, [target]: e.value })
              }
            />
          </div>
          <div className="header-select">
            <FilterSelect
              name="skills"
              filterItemExtraStyle="flex-grow-1"
              defaultValue={template || generalFilter}
              filterItemIcon="mdi mdi-lightbulb-on-outline"
              filterItemTitle={t("Skill")}
              loadingData={loadingConversationForm}
              data={dataSkills}
              onChange={(target, e) =>
                setFilter({ ...filter, [target]: e.map((e) => e.value) })
              }
              isMulti
            />
          </div>
          <div className="header-select">
            <ButtonCheckboxTree
              data={dataGroups}
              infoGroups={(e) => setInfoGroups(e)}
              defaultValue={template?.groups || generalFilter?.groups}
              name="groups"
              filterItemExtraStyle=""
              filterItemIcon="mdi mdi-account-group-outline"
              filterItemTitle={t("Groups")}
              loadingData={loadingConversationForm}
              onChange={(target, e) => {
                setFilter((old) => ({
                  ...old,
                  [target]: e?.map((g) => g?.uuid),
                }));
              }}
            />
          </div>
          <div className="pt-2 pl-0 align-self-end">
            <div className="d-flex w-100 justify-content-around pl-0">
              <Button
                id="Popover2"
                className={`header-button-filter ${mainTheme} mr-2`}
              >
                <i className="bx bx-folder mr-2 align-self-center"></i>
                {t("Saved Filters")}
              </Button>
              <ManagerFilterButton filter={filter} />
            </div>
          </div>
        </div>
      </Container>
      <Popover
        placement="bottom"
        isOpen={popoverOpen}
        className="popover-template-filter"
        target="Popover2"
        toggle={togglePop}
        trigger="click"
      >
        <PopoverBody className={`${mainTheme}`}>
          <Card className={`m-3 p-3 card ${mainTheme}`}>
            <CardTitle>{t("Filters")}</CardTitle>
            <div className="search-box chat-search-box flex-gdiv-1 p-2">
              <div className="position-relative">
                <Input
                  id="searchInput"
                  type="text"
                  className="form-control "
                  placeholder={t("Search")}
                  autoComplete="off"
                  onChange={handleChangeSearch}
                />
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>

            <div>
              {loadingUserFilter && (
                <div className="text-center">
                  <Spinner animation="border" size="sm" />
                </div>
              )}

              {!loadingUserFilter &&
              dataUserGetSetFilter?.data?.template_filters === null ? (
                <div className="text-center mt-2">{t("Filter not found")}</div>
              ) : (
                dataUserGetSetFilter?.data?.template_filters
                  ?.filter((el, key) => {
                    if (searchFilter === "") {
                      return (
                        <div
                          key={key}
                          className={`item-filter ${
                            filterSelected === el.name ? "selected" : ""
                          }`}
                          onClick={handleFilters}
                        >
                          {el.name}
                        </div>
                      );
                    } else if (
                      el.name.toLowerCase().includes(searchFilter.toLowerCase())
                    ) {
                      return (
                        <div
                          key={key}
                          className={`item-filter ${
                            filterSelected === el.name ? "selected" : ""
                          }`}
                          onClick={handleFilters}
                        >
                          {el.name}
                        </div>
                      );
                    }
                  })
                  .map((el, key) => {
                    return (
                      <div
                        key={key}
                        className={`item-filter ${
                          filterSelected === el.name ? "selected" : ""
                        }`}
                        onClick={handleFilters}
                      >
                        {el.name}
                      </div>
                    );
                  })
              )}
            </div>
          </Card>
          <div className="w-100 ml-2 reset-filter" onClick={handleResetFilters}>
            <i className="bx bx-undo mr-2"></i>
            {t("Reset filters")}
          </div>
          <div className="w-100 text-center">
            <Button
              color="primary"
              className="m-2"
              onClick={toggle}
              disabled={
                dataUserGetSetFilter?.data?.template_filters?.length === 3
                  ? true
                  : false
              }
            >
              <i className="bx bx-save mr-2"></i>
              {t("Save")}
            </Button>
            <Modal isOpen={modal}>
              <ModalHeader>{t("Save")}</ModalHeader>
              <ModalBody>
                <Card className="border p-2">
                  <Label>{t("Selected filters")}</Label>
                  <div className="d-flex mb-2">
                    {t("Groups")}:
                    {filter?.groups?.length ? (
                      <div style={{ width: "200px" }}>
                        <BadgesEllipsisSoft
                          objItems={getNameGroups()}
                          showDynamic={true}
                          tooltipBigName={20}
                          total={1}
                          isTooltip
                        />
                      </div>
                    ) : (
                      <BadgesEllipsisSoft
                        objItems={[{ name: t("All groups") }]}
                      />
                    )}
                  </div>
                  <div className="d-flex mb-2">
                    {t("Period")}:
                    <BadgesEllipsisSoft
                      objItems={[{ name: filter?.interval }]}
                    />
                  </div>
                  <div className="d-flex">
                    {t("Skills")}:
                    {filter?.skills?.length ? (
                      <div style={{ width: "200px" }}>
                        <BadgesEllipsisSoft
                          objItems={getNameSkills()}
                          showDynamic={true}
                          tooltipBigName={20}
                          total={1}
                          isTooltip
                        />
                      </div>
                    ) : (
                      <BadgesEllipsisSoft
                        objItems={[{ name: t("All skills") }]}
                      />
                    )}
                  </div>
                </Card>
                <AvForm>
                  <AvField
                    name="name"
                    label={t("Name")}
                    type="text"
                    onChange={handleChangeNameFilter}
                    validate={{
                      required: { value: true },
                      minLength: { value: 3 },
                      maxLength: { value: 255 },
                    }}
                  />
                </AvForm>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="primary"
                  onClick={onSubmitFilter}
                  disabled={
                    nameFilter?.length >= 3 && nameFilter.length <= 255
                      ? false
                      : true
                  }
                >
                  {loadingUserUpdateFilter ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    t("Confirm")
                  )}
                </Button>

                <Button
                  color="secondary"
                  onClick={(e) => {
                    setModal(false);
                  }}
                >
                  {t("Cancel")}
                </Button>
              </ModalFooter>
            </Modal>
            <Button
              color="danger"
              disabled={filterSelected?.length ? false : true}
              onClick={(e) => {
                onDeleteFilter();
              }}
            >
              {loadingUserUpdateFilter && nameFilter?.length === 0 ? (
                <div className="text-center">
                  <Spinner animation="border" size="sm" />
                </div>
              ) : (
                <>
                  <i className="bx bx-trash mr-2"></i>
                  {t("Delete")}
                </>
              )}
            </Button>
          </div>
        </PopoverBody>
      </Popover>
    </React.Fragment>
  );
};
export default withTranslation()(ManagerFilterHeader);
